<template>
  <div class="meter-transfer-form page">
    <van-nav-bar left-text="返回" :title="$route.meta.title" @click-left="$comm.onClickLeft" v-show="$comm.titleShow()" left-arrow fixed>
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>

    <van-form @submit="onSubmit" :validate-trigger="$trigger" v-show="active1 == 0" class="van-form-without-tab">
      <van-cell-group title="基本信息">
        <van-field readonly clickable :disabled="!falg" v-model="ftype" label="问题类别" placeholder="请选择问题类别" @click="showFtype = falg" :required="true" :rules="[{ required: true, message: '请选择问题类别'}]">
          <template #right-icon>
            <span class="iconfont iconxuanzesanjiao"></span>
          </template>
        </van-field>
        <van-popup v-model="showFtype" position="bottom">
          <van-picker title="问题类别" :disabled="!falg" show-toolbar :columns="columns" @cancel="showFtype = false" @confirm="ftypeConfirm" />
        </van-popup>
        <van-field required :disabled="!falg" v-model="form.fremark" rows="2" autosize label="问题情况" type="textarea" maxlength="500" placeholder="请输入问题情况" :rules="[{ required: true, message: '请输入问题情况'  }]" show-word-limit />
        <van-field v-model="fareaid" :disabled="!falg" clickable required label="报修区域" placeholder="请选择所在报修区域" @click="fareaidShow = falg" :rules="[{ required: true, message: '请选择所在报修区域'  }]">
          <template #right-icon>
            <span class="iconfont iconxuanzesanjiao"></span>
          </template>
        </van-field>
        <van-popup v-model="fareaidShow" round position="bottom">
          <van-cascader :disabled="!falg" v-model="cascaderValue" title="请选择所在报修区域" :options="fareaidOptions" @close="fareaidShow = false" @change="onFareaidChange" @finish="onFinish" />
        </van-popup>
        <van-field required :disabled="!falg" v-model="form.foper" label="联系人" placeholder="请输入联系人" :rules="[{ required: true, message: '请输入联系人' }]" />
        <van-field required :disabled="!falg" :rules="[{ pattern: $pattern, message: '请输入正确的手机号' }]" v-model="form.fopermobile" label="联系手机" placeholder="请输入手机号" />
        <van-field required :disabled="!falg" v-model="form.faddr" label="详细地址" placeholder="请输入详细地址" :rules="[{ required: true, message: '请输入详细地址' }]" />
      </van-cell-group>

      <van-cell-group title="图片资料">
        <van-field required name="masterUrls" label="" :rules="[{
                    required: true,
                    message: '请上传图片资料'}]">
          <template #input>
            <van-uploader :disabled="!falg" :deletable="!$route.query.readonly" :show-upload="!$route.query.readonly" multiple :max-count="3" v-model="uploaderMst" :after-read="imgAfterReadMaster" @delete="imgOnDeleteMaster" />
          </template>
        </van-field>
      </van-cell-group>

      <van-cell-group title="视频文件">
        <van-field name="uploaderMst" label="" :rules="[{required: false, message: $idcardmsg}]">
          <template #input>
            <van-uploader :disabled="!falg" :deletable="!$route.query.readonly" :show-upload="!$route.query.readonly" multiple :max-count="1" accept="video/*" v-model="videoMst" :after-read="videoAfterReadMaster" @delete="videoOnDeleteMaster" />
          </template>
        </van-field>
      </van-cell-group>

      <div v-show="!falg">
        <van-cell-group title="处理结果">
          <van-field v-model="form.fnetstatusname" label="处理状态" placeholder="请输入处理状态" />
          <van-field v-model="form.fnetcheckmark" rows="2" autosize label="处理意见" type="textarea" maxlength="200" placeholder="" show-word-limit />
        </van-cell-group>
      </div>
      <yonghuxuzhi v-show="falg" @changeChecked="changeChecked" :typecode="typecode" :ftrantype="1"></yonghuxuzhi>

      <van-button v-show="falg" :disabled="!checked||!falg" block type="info" native-type="submit">
        提交
      </van-button>
    </van-form>

  </div>
</template>

<script>

export default {
  name: 'MeterTransferForm',
  data() {
    return {
      typecode: 213,
      active: 0,
      active1: 0,
      popShow: false,
      uploaderMst: [], // vant自带缩略图站位
      videoMst: [], // vant自带缩略图站位
      masterUrls: [], // 图片集合
      videoUrls: [], // 视频集合
      uploaderHs: [],
      uploaderOpt: [],
      hourseUrls: [],
      optUrls: [],
      message: '',
      radio: '1',
      fareaid: '',
      form: {
        fsou: this.$comm.titleShow() ? 2 : 4,
        ftype: '',
        fremark: "",
        fareaid1: "",
        fareaid2: "",
        fareaid: '',
        foper: "",
        fopermobile: "",
        faddr: '',
        attach: []
      },
      value: '',
      showPicker: false,
      isNameSame: false,
      areaList: {},
      showFtype: false,
      columns: [],
      fareaidShow: false,
      fareaidOptions: [],
      cascaderValue: '',
      ftype: '',
      falg: this.$route.query.busstype ? false : true,
      checked: false
    }
  },
  mounted() {
    this.getFtype() // 查询问题类别
    this.getFareaid() // 查询区域
    if (!this.falg) {
      this.info()
    }
  },
  methods: {
    changeChecked(checked) {
      this.checked = checked
    },
    // 回显详情
    info() {
      this.$http.post(this.$api.serviceinfo, {
        busstype: this.$route.query.busstype,
        bussno: this.$route.query.bussno
      }).then(res => {
        if (res.code === '000') {
          this.form = res.data
          let result = this.$comm.butlerAttach(res.data)
          this.uploaderMst = result.uploaderMst
          this.videoMst = result.videoMst
          this.masterUrls = result.masterUrls
          this.videoUrls = result.videoUrls
          if (this.form.ftype) {
            this.columns.forEach(el => {
              if (el.code === this.form.ftype) {
                this.ftype = el.text
              }
            })
          }
          if (this.form.fareaid1) {
            this.fareaidOptions.forEach(el => {
              if (el.value === this.form.fareaid1) {
                this.$http.post(this.$api.getBasedata, {
                  "typeid": 3,
                  "parentid": this.form.fareaid1
                }).then(re => {
                  if (res.code === '000') {
                    re.data.forEach(ell => {
                      if (ell.fid == this.form.fareaid2) {
                        this.fareaid = el.text + '/' + ell.fname
                      }
                    })
                  } else {
                    this.$toast(re.msg)
                  }
                })
              }
            })
          }
          this.$clear()
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 查询问题类别
    getFtype() {
      this.columns = []
      this.$http.post(this.$api.getBasedata, {
        "typeid": 11,
        "parentid": 0
      }).then(res => {
        if (res.code === '000') {
          res.data.forEach(el => {
            this.columns.push({
              text: el.fname,
              code: el.fid
            })
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 选择问题类别
    ftypeConfirm(obj, index) {
      this.ftype = obj.text
      this.form.ftype = this.columns[index].code
      this.showFtype = false
    },
    // 查询区域
    getFareaid() {
      this.fareaidOptions = []
      this.$http.post(this.$api.getBasedata, {
        "typeid": 1,
        "parentid": 0
      }).then(res => {
        if (res.code === '000') {
          res.data.forEach(el => {
            this.fareaidOptions.push({
              text: el.fname,
              value: el.fid,
              children: []
            })
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 监听选择区域
    onFareaidChange({ value }) {
      for (let i = 0; i < this.fareaidOptions.length; i++) {
        if (value == this.fareaidOptions[i].value) {
          this.fareaidOptions[i].children = []
          this.$http.post(this.$api.getBasedata, {
            "typeid": 3,
            "parentid": value
          }).then(res => {
            if (res.code === '000') {
              res.data.forEach(el => {
                this.fareaidOptions[i].children.push({
                  text: el.fname,
                  value: el.fid
                })
              })
            } else {
              this.$toast(res.msg)
            }
          })
          break
        }
      }
    },
    // 选择区域
    onFinish({ selectedOptions }) {
      this.fareaidShow = false
      this.form.fareaid1 = selectedOptions[0].value
      if (selectedOptions.length > 1) {
        this.form.fareaid2 = selectedOptions[1].value
      }
      this.fareaid = selectedOptions.map((option) => option.text).join('/');
    },
    // 图片上传
    imgAfterReadMaster(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.masterUrls.push(res.data)
        } else {
          this.$toast('上传失败')
        }
      })
    },
    // 图片删除
    imgOnDeleteMaster(file, detail) {
      this.masterUrls.splice(detail.index, 1)
    },
    // 视频上传
    videoAfterReadMaster(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.videoUrls.push(res.data)
        } else {
          this.$toast('上传失败')
        }
      })
    },
    // 视频删除
    videoOnDeleteMaster(file, detail) {
      this.videoUrls.splice(detail.index, 1)
    },
    // 手机号码格式验证
    nameChange() {
      if (this.form.uname === this.form.operator) {
        this.isNameSame = true
      } else {
        this.isNameSame = false
      }
    },
    // 提交
    onSubmit() {
      this.masterUrls.forEach(img => {
        this.form.attach.push({
          typeid: "0",
          url: img
        })
      })
      this.videoUrls.forEach(video => {
        this.form.attach.push({
          typeid: "14",
          url: video
        })
      })
      this.$http.post(this.$api.serviceRepair, this.form).then(res => {
        if (res.code === '000') {
          this.$router.push({
            path: '/business/success',
            query: {
              title: this.$route.meta.title,
              from: '水管家服务',
              path: '/mine/baoxiuxinxi'
            }
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.meter-transfer-form {
  /deep/ .van-radio-group.van-radio-group--horizontal {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(33, 33, 33, 1);

    .van-radio--horizontal {
      margin-right: 0;
      margin-left: 4px;

      .van-radio__label {
        margin-left: 2px;
      }
    }
  }

  .form-pop {
    width: 85%;
    height: 60%;
    border-radius: 4px;
    font-size: 12px;
  }
}
</style>